module.exports = __webpack_public_path__ + "static/subway-dc267b492dca39dd4f3f86266e94094c.jpg";